module.exports = __webpack_public_path__ + "static/img/xsdz.cbd3e707.png";